import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0c6d4998&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=0c6d4998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d4998",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuDetail: require('/workspace/components/Menu/MenuDetail.vue').default,MenuMainAction: require('/workspace/components/Menu/MenuMainAction.vue').default,MenuItem: require('/workspace/components/Menu/MenuItem.vue').default})
